module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGElEQVQoz2NgIAeYh978Twwe1TDUNZACAA/C7xGQYrl2AAAAAElFTkSuQmCC"